///////////////////////////////////////////////
//           Icon styles                     //
///////////////////////////////////////////////

@import './pk-icon.variables';

:host {
  @apply relative box-content flex h-[var(--icon--width)] w-[var(--icon--width)] text-[color:var(--icon--color)];
}

.c-icon--outline {
  svg {
    @apply h-full w-full;

    > * {
      @apply h-full w-full;
    }
  }

  .pk-svg__icon {
    @apply block overflow-hidden fill-current;

    > * {
      @apply fill-current;
    }
  }
}
